<script lang="ts">
    import {Question} from "../../models/Question";
    import {onDestroy} from "svelte/internal";
    import {
        updateQuestionAnswer,
        updateDisclosure,
        updateSpecifiedDisclosure, removeQuestionAnswer, replaceQuestionInCollection
    } from "../../services/QuestionDataService";
    import Select from 'svelte-select';
    import {get} from "svelte/store";
    import {Disclosures} from "../../services/Store";
    import {UpdateDisclosureRequest} from "../../models/UpdateDisclosureRequest";
    import {UpdateSpecifiedDisclosureRequest} from '../../models/UpdateSpecifiedDisclosureRequest';
    import {PickListItem} from "../../models/PickListItem";
    import {SuspectedCondition} from "../../models/SuspectedCondition";
    import {getSuspectedConditionsForBaseQuestion, updateQuestionsAnswered} from "../../services/Utilities";

    export let question: Question
    export let suspectedConditions: SuspectedCondition[] = [];

    let matchedSuspectedConditions: SuspectedCondition[] = [];
    let searchItems = get(Disclosures);

    let disclosureContainer;
    let suspectedConditionsContainer;
    let selectControl;

    let specifiedAnswer = '';

    const updateDisclosureItem = (item: any) => {
        const request = new UpdateDisclosureRequest();
        request.questionCode = question.code.toString();
        request.disclosureAlias = item.alias;
        request.disclosureValue = item.selected;
        updateDisclosure(request);
    }

    const updateSpecifiedDisclosureAnswer = () => {
        const request = new UpdateSpecifiedDisclosureRequest();
        request.questionCode = question.code.toString();
        request.disclosureAlias = question.disclosureAlias.toString();
        request.disclosureValue = specifiedAnswer.toString();
        updateSpecifiedDisclosure(request);
    }

    const answerYesToQuestion = async () => {
        question.answerText = 'Yes';
        question.value = 'true';
        const result = await updateQuestionAnswer(question);
        const suspectedConditions = getSuspectedConditionsForBaseQuestion(question.code.toString());
        if (suspectedConditions.length > 0) {
            result.showSuspectedConditions = true;
            result.suspectedConditions = suspectedConditions;
            question.showSuspectedConditions = true;
            question.suspectedConditions = suspectedConditions;
        }
        question.showPicklist = result.showPicklist;
        question.pickListItems = result.pickListItems;
        question.pickListSearchEnabled = result.pickListSearchEnabled;
        updateQuestionsAnswered(question.code.toString(), 'true');
        question = {...result};
    }

    const answerNoToQuestion = async () => {
        question.showPicklist = false;
        question.answerText = 'No';
        question.value = 'false';
        question = await updateQuestionAnswer(question);
        updateQuestionsAnswered(question.code.toString(), 'false');
    }

    const answerNotSureToQuestion = async() => {
        question.showPicklist = false;
        question.showSuspectedConditions = false;
        question.answerText = 'Not Sure';
        question.value = '';
        question = await removeQuestionAnswer(question);
        updateQuestionsAnswered(question.code.toString(), 'notSure');
    }

    onDestroy(() => {
        searchItems = [];
    })

    const addItemToPicklist = (item) => {
        if (item && item.detail && item.detail.value) {
            let tempArray = [...question.pickListItems];
            tempArray.push(new PickListItem(item.detail.value, true));
            question.showPicklist = true;
            question.pickListItems = tempArray;
            const picklistDataItem = new PickListItem(item.detail.value, true);
            updateDisclosureItem(picklistDataItem);
            replaceQuestionInCollection(question);
        }
    }

    $:  if (question) {
    }
</script>

<div class="yes-no-question-container">
    <div class="yes-no-question">
        <div class="question-button-container">
            <button class="{question.answerText === 'Yes' ? 'question-button selected' : 'question-button'}" on:click={() => answerYesToQuestion()}>Yes</button>
            <button class="{question.answerText === 'No' ? 'question-button selected' : 'question-button'}" on:click={() => answerNoToQuestion()}>No</button>
            <button class="{question.answerText === 'Not Sure' ? 'large-question-button selected' : 'large-question-button'}" on:click={() => answerNotSureToQuestion()}>I Don't Know</button>
        </div>
        <div class="question-text">
            {question.text}
        </div>
    </div>
    {#if question.pickListSearchEnabled}
        <div class="search-container">
            <div class="disclosure-spacer">&nbsp;</div>
            <div class="themed">
                <Select bind:this={selectControl} items={searchItems} placeholder="Search All That Apply..." on:select={addItemToPicklist}></Select>
            </div>
        </div>
        {/if}
    {#if question.showPicklist}
        <div class="disclosures-container" id="disclosures">
            <div class="disclosure-spacer">&nbsp;</div>
            <div class="disclosures" bind:this={disclosureContainer}>
                {#each question.pickListItems as item}
                    <div class="question-text disclosure-item">
                        <input type="checkbox" bind:checked={item.selected} on:change={() => updateDisclosureItem(item)}>{item.alias}
                    </div>
                {/each}
            </div>
        </div>
    {/if}
    {#if question.showSuspectedConditions}
        <div class="suspected-conditions-container">
            <div class="disclosure-spacer">&nbsp;</div>
            <div class="suspected-conditions" bind:this="{suspectedConditionsContainer}">
                <div>
                    Please select the condition(s) below, if applicable.
                </div>
                <hr />
                {#each question.suspectedConditions as item}
                    <div class="question-text disclosure-item">
                        <input type="checkbox" bind:checked={item.selected} on:change={() => updateDisclosureItem(item)}>{item.alias}
                    </div>
                    {/each}
            </div>
        </div>
    {/if}
    {#if question.showFreeformTextBox}
    <div class="specified-answer-container">
        <div class="disclosure-spacer">&nbsp;</div>
        <div>
            <div>
                Please enter details about the question
            </div>
            <textarea cols="120" rows="4" id="specifiedDisclosureAnswer" bind:value={specifiedAnswer} on:focusout={updateSpecifiedDisclosureAnswer}></textarea>
        </div>

    </div>
        {/if}
</div>


<style lang="scss">
  @use "../../../component_scss_library/questions";
  @use "../../../component_scss_library/colors" as colors;
  @use "../../../component_scss_library/fonts" as fonts;

    .yes-no-question-container {
      display: flex;
      flex-direction: column;
    }
    .yes-no-question {
      display: flex;
      flex-direction: row;
    }

    .disclosures-container {
      display: flex;
      flex-direction: row;
      margin: 20px 0 10px 0;
    }
    .disclosures {
      display: block;isplay: flex;
        flex-direction: column;
     }
    .disclosure-item {
        padding: 4px 0 4px 0;
    }
    .question-button-container {
      width: 300px;
    }
    .search-container {
      display: flex;
      flex-direction: row;
      margin: 10px 0 10px 0;
      input {
        width: 140px;
      }
      @include fonts.primary;
    }
    .specified-answer-container {
      display: flex;
      flex-direction: row;
      margin: 10px 0 10px 0;
      @include fonts.primary;
      textarea {
      }
    }
    .suspected-conditions-container {
      display: flex;
      flex-direction: row;
      margin: 10px 0 10px 0;
      @include fonts.primary;
    }
    .themed {
      border: 2px solid colors.$primary;
      border-radius: 10px;
      placeholderColor: colors.$primary;
      width: 420px;
      @include fonts.primary;
    }
    .search-box {
      border: 30px solid colors.$primary;
    }
    .disclosure-spacer {
      width: 312px;
    }
</style>
